import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function Login({ setIsAuthenticated, setUserRole }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/auth/login', { username, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setIsAuthenticated(true);
      setUserRole(response.data.user.role);
      
      if (response.data.user.role === 'admin') {
        navigate('/admin/dashboard');
      } else {
        navigate('/form');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ 
        maxWidth: '500px',
        marginTop: '50px',
        background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Dekoratif köşe */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '150px',
          height: '150px',
          background: 'linear-gradient(135deg, #ff0000, #ff6666)',
          borderRadius: '50%',
          opacity: '0.2',
          animation: 'pulse 3s infinite'
        }}></div>

        <div style={{
          position: 'absolute',
          bottom: '-30px',
          left: '-30px',
          width: '100px',
          height: '100px',
          background: 'linear-gradient(135deg, #ff0000, #ff6666)',
          borderRadius: '50%',
          opacity: '0.2',
          animation: 'pulse 3s infinite 1s'
        }}></div>

        <div style={{ textAlign: 'center', marginBottom: '30px', position: 'relative', zIndex: 1 }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            background: 'linear-gradient(135deg, #ff0000, #cc0000)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px',
            color: '#fff',
            boxShadow: '0 8px 20px rgba(255, 0, 0, 0.4)',
            animation: 'fadeIn 0.8s ease-in'
          }}>
            🔐
          </div>
          <h2 style={{ 
            color: '#ff0000', 
            marginBottom: '10px',
            fontSize: '28px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            Hoş Geldiniz
          </h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Devam etmek için giriş yapın
          </p>
        </div>
        
        {error && (
          <div style={{ 
            backgroundColor: '#ffcccc', 
            color: '#cc0000', 
            padding: '15px', 
            borderRadius: '10px',
            marginBottom: '20px',
            border: '2px solid #ff0000',
            animation: 'shake 0.5s',
            textAlign: 'center',
            fontWeight: 'bold'
          }}>
            ❌ {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ position: 'relative', zIndex: 1 }}>
          <div className="form-group">
            <label style={{ 
              display: 'flex', 
              alignItems: 'center',
              fontSize: '15px',
              marginBottom: '10px'
            }}>
              <span style={{ marginRight: '8px' }}>👤</span>
              Kullanıcı Adı
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              placeholder="Kullanıcı adınızı girin"
              style={{
                fontSize: '16px',
                padding: '14px',
                borderRadius: '10px'
              }}
            />
          </div>

          <div className="form-group">
            <label style={{ 
              display: 'flex', 
              alignItems: 'center',
              fontSize: '15px',
              marginBottom: '10px'
            }}>
              <span style={{ marginRight: '8px' }}>🔒</span>
              Şifre
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="Şifrenizi girin"
              style={{
                fontSize: '16px',
                padding: '14px',
                borderRadius: '10px'
              }}
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
            style={{
              width: '100%',
              padding: '15px',
              fontSize: '18px',
              fontWeight: 'bold',
              marginTop: '10px',
              borderRadius: '10px',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {loading ? (
              <>
                <span style={{ animation: 'pulse 1s infinite' }}>⏳</span> Giriş Yapılıyor...
              </>
            ) : (
              <>
                🚀 Giriş Yap
              </>
            )}
          </button>
        </form>

        <div style={{
          marginTop: '30px',
          textAlign: 'center',
          color: '#999',
          fontSize: '12px',
          position: 'relative',
          zIndex: 1
        }}>
          <p>© 2024 Mim Bytes - Ziyaretçi Kayıt Sistemi</p>
        </div>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-10px); }
          75% { transform: translateX(10px); }
        }
      `}</style>
    </div>
  );
}

export default Login;
